import React, { Component } from 'react';
import {
    Form, Input, Select, Button,
} from 'antd';

class AdminCompaniesAddView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item>
                        {getFieldDecorator('username', {
                            rules: [{ required: true, message: 'Ingrese el username' }],
                        })(
                            <Input placeholder="Username" />,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('email', {
                            rules: [{ required: true, message: 'Ingrese el email' }],
                        })(
                            <Input placeholder="Email" />,
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: 'Ingrese la contraseña' }],
                        })(
                            <Input type="password" placeholder="Contraseña" />,
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('rol', {
                            rules: [{ required: true, message: 'Ingrese el rol' }],
                        })(
                            <Select placeholder="Seleccione un rol">
                                <Select.Option value="admin">
                                    Administrador
                                </Select.Option>
                                <Select.Option value="tecnico">
                                    Tecnico
                                </Select.Option>
                                <Select.Option value="supervisor">
                                    Supervisor
                                </Select.Option>
                            </Select>,
                        )}

                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Guardar
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

export default Form.create()(AdminCompaniesAddView);



// WEBPACK FOOTER //
// ./src/components/views/AdminCompaniesAddUserView.js